export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '5px 10px',
    backgroundColor: '#FFF',
    color: '#000'
  },
  switchRow: {
    display: 'flex',
    alignItems: 'center'
  }
};
